import { PkDropdown, PkIcon, PkMenu, PkMenuItem } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useHeaderOptions } from '../../model';
import { handleHeaderItemClick } from '../../utils';

import { useWindowSize } from '@hooks/useWindowSize';
import Image from '@shared/Image';
import type { MenuItem } from '@shared-types/menu.types';
import { imgBaseUrl } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const DropdownItem = ({ item }: { item: MenuItem }) => {
  const { isHoverDevice } = useWindowSize();
  const {
    options: { theme },
  } = useHeaderOptions();

  return (
    <PkDropdown
      placement='bottom-end'
      pk-theme={theme === 'dark' ? 'light' : 'dark'}
      className={styles.dropdown}
      showOn={isHoverDevice ? 'hover' : 'click'}
      title={item.text}
    >
      <div className='pk-d--flex pk-gap--xs2 pk-align-items--center pk-text--text-01' slot='trigger' pk-theme={theme}>
        {item.icon?.startsWith('/') ? (
          <Image slot='trigger' src={`${imgBaseUrl}/imgml/${item.icon}`} alt={item.text} />
        ) : (
          <>
            {!!item.icon && <PkIcon name={item.icon} color='text-01' />}
            {item.text}
          </>
        )}
      </div>
      <PkMenu className={styles.menu} hideSectionDivider>
        {item.menuItems?.map((subItem) => (
          <PkMenuItem
            aria-label={subItem.text}
            title={subItem.text}
            key={subItem.id}
            href={subItem.href}
            linkTarget={subItem.target}
            onClick={handleHeaderItemClick(subItem)}
            onAuxClick={handleHeaderItemClick(subItem)}
          >
            <span className='pk-d--flex pk-justify-content--between pk-align-items--center pk-text--text-01 pk-font--base-regular'>
              {subItem.text}
              <PkIcon name='support-external' color='text-03' />
            </span>
          </PkMenuItem>
        ))}
      </PkMenu>
    </PkDropdown>
  );
};

export default memo(DropdownItem);
